module.exports = __webpack_public_path__ + "img/3_1.7c323c1c.png";